/* =========================================================================
   Grooming PDP — "Matches your acne prone skin" and a routine to match.

   What the shopper has told us lives in their personalization profile
   (assets/vro-personalization.js): the quiz's problems ("Acne",
   "Dandruff"…) and the answer to "what does your skin usually do?". This
   file reads that and, on the grooming PDP
   (sections/main-product-grooming.liquid):

     1. rewrites the highlight line under the title to "Matches your <x>"
        — only when this product's own data answers <x>; otherwise the
        merchant's line stays, so nothing untrue is claimed;
     2. fills [skin] in the "Buy the routine" subheading and "why" lines
        ("right for your acne prone skin");
     3. brings the routine products that answer the concern to the front of
        each step (the step renders a few spares for this).

   No shopper data, no engine, or no match: the page is exactly as
   rendered. Re-runs when the profile changes (a quiz answered elsewhere on
   the page, or a profile pulled from the server).
   ========================================================================= */
(function () {
  'use strict';
  if (window.VroPdpMatch) return;

  /* How each quiz problem reads after "Matches your …". */
  var PROBLEM_PHRASES = {
    'acne': 'acne prone skin',
    'dark spots': 'skin with dark spots',
    'dryness': 'dry skin',
    'oiliness': 'oily skin',
    'sunburn': 'sun-exposed skin',
    'fine lines': 'skin with fine lines',
    'hairfall': 'hair fall',
    'dandruff': 'dandruff-prone scalp',
    'slow hair growth': 'slow hair growth',
    'split ends': 'split ends',
    'itchy scalp': 'itchy scalp'
  };
  var SKIN_PHRASES = {
    'oily': 'oily skin',
    'dry': 'dry skin',
    'combination': 'combination skin',
    'sensitive': 'sensitive skin'
  };
  var GROOMING_CATEGORIES = ['skin', 'hair & scalp'];

  function engine() { return window.VroPersonalization || null; }
  function norm(v) {
    var e = engine();
    if (e && e.normalize) return e.normalize(v);
    return String(v || '').toLowerCase().replace(/[^a-z0-9%+]+/g, ' ').trim();
  }

  /* What the shopper told us, in the order it should be trusted: the
     concerns they named in the quiz, then what their skin does. */
  function shopper() {
    var e = engine();
    if (!e || !e.profile) return null;
    var p;
    try { p = e.profile.get(); } catch (err) { return null; }
    if (!p) return null;

    var out = { problems: [], skin: null, skinLabel: null };
    var quiz = p.quiz;
    if (quiz && quiz.category && GROOMING_CATEGORIES.indexOf(String(quiz.category).toLowerCase()) > -1) {
      (quiz.problems || []).forEach(function (pr) {
        var key = String(pr || '').toLowerCase().trim();
        if (key && PROBLEM_PHRASES[key]) out.problems.push(key);
      });
    }

    /* The newest skin answer wins: the same question is asked on several
       home-page rails and on this card's Retake, each under its own key. */
    var facets = p.facets || {};
    var at = p.facetAt || {};
    var keys = Object.keys(facets);
    var newest = -1;
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].split('@')[0] !== 'skin') continue;
      var label = facets[keys[i]];
      if (typeof label !== 'string' || !label) continue;
      var cond = skinConditionOf(label);
      var when = at[keys[i]] || 0;
      if (SKIN_PHRASES[cond] && when > newest) { newest = when; out.skin = cond; out.skinLabel = label; }
    }
    /* The home page's "What does your skin usually do?" answers with a
       collection rather than a facet, so it is filed as answer@<section>
       by assets/vro-quiz-memory.js. Same answer, same weight. */
    for (var j = 0; j < keys.length; j++) {
      if (keys[j].indexOf('answer@') !== 0) continue;
      var v = facets[keys[j]];
      if (!v || typeof v !== 'object' || !v.a || !/skin/i.test(String(v.q || '') + ' ' + String(v.s || ''))) continue;
      var c2 = skinConditionOf(v.a);
      var when2 = at[keys[j]] || 0;
      if (SKIN_PHRASES[c2] && when2 > newest) { newest = when2; out.skin = c2; out.skinLabel = v.a; }
    }
    /* "What are we sorting out?" -> Skin -> "How's your skin right now". */
    if (quiz && quiz.condition && GROOMING_CATEGORIES.indexOf(String(quiz.category || '').toLowerCase()) > -1 &&
        String(quiz.category).toLowerCase() === 'skin') {
      var c3 = skinConditionOf(quiz.condition);
      if (SKIN_PHRASES[c3] && (p.quizAt || 0) > newest) { newest = p.quizAt || 0; out.skin = c3; out.skinLabel = quiz.condition; }
    }
    if (!out.problems.length && !out.skin) return null;
    return out;
  }

  /* A skin answer, in any of the wordings the quizzes use. */
  var SKIN_WORDS = {
    'gets oily by noon': 'oily', 'oily by noon': 'oily', 'oily': 'oily', 'oily skin': 'oily',
    'feels tight and dry': 'dry', 'dry': 'dry', 'dry skin': 'dry',
    'a bit of both': 'combination', 'combination': 'combination', 'combination skin': 'combination',
    'reacts to most things': 'sensitive', 'sensitive': 'sensitive', 'sensitive skin': 'sensitive'
  };
  function skinConditionOf(label) {
    var n = norm(label);
    if (SKIN_WORDS[n]) return SKIN_WORDS[n];
    var e = engine();
    return e && e.facetCondition ? e.facetCondition('skin', label) : n;
  }

  function blobOf(el) {
    return norm([
      el.getAttribute('data-vro-signals'),
      el.getAttribute('data-vro-tags'),
      el.getAttribute('data-vro-benefits'),
      el.getAttribute('data-vro-title')
    ].join(' | '));
  }

  function answersProblem(el, problem) {
    var e = engine();
    var signals = (e && e.problemSignals && e.problemSignals[problem]) || [problem];
    var blob = blobOf(el);
    for (var i = 0; i < signals.length; i++) {
      if (blob.indexOf(norm(signals[i])) > -1) return true;
    }
    return false;
  }

  /* > 0: the product says it is for this skin; 0: says nothing either way
     (or "all skin types"); < 0: it is for the opposite. */
  function skinScore(el, who) {
    var e = engine();
    if (!who.skin || !e || !e.facetScore) return 0;
    try { return e.facetScore(el, 'skin', who.skin, 'skin'); } catch (err) { return 0; }
  }

  function declaresUniversal(el) {
    var t = norm(el.getAttribute('data-vro-skin-type') || '');
    return /\ball\b|every|normal/.test(t);
  }

  /* The phrase to show for this product, or null when it does not answer
     anything the shopper told us. */
  function matchPhrase(el, who) {
    for (var i = 0; i < who.problems.length; i++) {
      if (answersProblem(el, who.problems[i])) return PROBLEM_PHRASES[who.problems[i]];
    }
    if (who.skin) {
      var s = skinScore(el, who);
      if (s > 0 || (s === 0 && declaresUniversal(el))) return SKIN_PHRASES[who.skin];
    }
    return null;
  }

  /* The phrase for the routine copy: what the shopper said, whether or not
     this particular product answers it — the routine is about them. */
  function shopperPhrase(who) {
    if (who.problems.length) return PROBLEM_PHRASES[who.problems[0]];
    if (who.skin) return SKIN_PHRASES[who.skin];
    return null;
  }

  /* The perfume quiz's answers, and the notes that fit each. A renamed
     answer falls back to its own words. */
  var SCENT_SIGNALS = {
    'fresh & effortless': ['fresh', 'citrus', 'aquatic', 'marine', 'ocean', 'green', 'aromatic', 'fougere', 'fougère', 'lavender', 'mint', 'bergamot', 'lemon', 'clean', 'cool'],
    'warm & magnetic': ['warm', 'amber', 'vanilla', 'spicy', 'spice', 'gourmand', 'sweet', 'cinnamon', 'tonka', 'saffron', 'honey', 'caramel', 'brown sugar'],
    'dark & intriguing': ['oud', 'leather', 'smoky', 'smoke', 'tobacco', 'incense', 'dark', 'intense', 'noir', 'night'],
    'rich & sophisticated': ['floral', 'woody', 'wood', 'musk', 'sandalwood', 'rose', 'chypre', 'iris', 'patchouli', 'jasmine', 'oriental', 'luxury'],
    /* "Which scent world pulls you in?" (a Homepage quiz entry). */
    'fresh & aquatic': ['aquatic', 'marine', 'ocean', 'aqua', 'water', 'fresh', 'citrus', 'bergamot', 'lemon', 'green', 'clean'],
    'woody': ['woody', 'wood', 'sandalwood', 'cedar', 'vetiver', 'oakmoss'],
    'oud and spicy': ['oud', 'spicy', 'spice', 'saffron', 'cardamom', 'pepper', 'leather', 'tobacco', 'incense'],
    'musky & sweet': ['musk', 'sweet', 'vanilla', 'gourmand', 'tonka', 'caramel', 'honey', 'amber']
  };

  /* The shopper's answer to the home page's perfume quiz, saved by
     assets/vro-quiz-memory.js as answer@<quiz> = { q, a }. */
  function scentAnswer() {
    var e = engine();
    if (!e || !e.profile) return null;
    var p;
    try { p = e.profile.get(); } catch (err) { return null; }
    var facets = (p && p.facets) || {};
    var at = (p && p.facetAt) || {};
    var keys = Object.keys(facets);
    var found = null;
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].indexOf('answer@') !== 0) continue;
      var v = facets[keys[i]];
      if (!v || typeof v !== 'object' || !v.a) continue;
      if (/perfume|scent|fragrance/i.test(String(v.q || '') + ' ' + keys[i])) {
        if (!found || (at[keys[i]] || 0) > found.at) found = { a: String(v.a), at: at[keys[i]] || 0, source: 'answer', p: v.p || [] };
      }
    }
    /* "What are we sorting out?" -> Fragrance -> the vibe. */
    var quiz = p && p.quiz;
    if (quiz && /fragrance|perfume|scent/i.test(String(quiz.category || '')) && quiz.problems && quiz.problems.length) {
      if (!found || (p.quizAt || 0) > found.at) found = { a: String(quiz.problems[0]), at: p.quizAt || 0, source: 'quiz', all: quiz.problems.slice() };
    }
    return found;
  }

  function scentFits(el, answer) {
    var key = norm(answer);
    var signals = null;
    Object.keys(SCENT_SIGNALS).forEach(function (k) { if (!signals && norm(k) === key) signals = SCENT_SIGNALS[k]; });
    var e = engine();
    if (!signals && e && e.problemSignals && e.problemSignals[key]) signals = e.problemSignals[key];
    signals = signals || key.split(/[^a-z]+/).filter(function (w) { return w.length > 2 && w !== 'and'; });
    var blob = blobOf(el) + ' | ' + norm(el.getAttribute('data-vro-scent') || '');
    for (var i = 0; i < signals.length; i++) {
      if (blob.indexOf(norm(signals[i])) > -1) return true;
    }
    return false;
  }

  /* A scent answer fits a perfume the quiz itself picked for it (the
     option's products) or one whose notes say it. */
  function scentMatches(el, scent, answer) {
    var handle = el.getAttribute('data-handle') || '';
    if (handle && scent && scent.p && scent.p.indexOf(handle) > -1 && answer === scent.a) return true;
    return scentFits(el, answer);
  }

  /* Skin type as the card names it: "Your skin is Oily". */
  var SKIN_NAMES = { oily: 'Oily', dry: 'Dry', combination: 'Combination', sensitive: 'Sensitive' };

  /* The concern as the shopper picked it: "Acne", "Dark spots". */
  function problemLabel(key) {
    var e = engine();
    var p;
    try { p = e && e.profile ? e.profile.get() : null; } catch (err) { p = null; }
    var list = (p && p.quiz && p.quiz.problems) || [];
    for (var i = 0; i < list.length; i++) {
      if (String(list[i]).toLowerCase().trim() === key) return String(list[i]);
    }
    return key.charAt(0).toUpperCase() + key.slice(1);
  }

  /* Does this product fit the skin they gave? A product that says it is for
     the other skin, or says nothing, does not. "All skin types" counts, as
     it always has on this card. */
  function fitsSkin(el, who) {
    if (!who || !who.skin) return false;
    /* A skin answer is about skin products. A shampoo or a beard oil whose
       data happens to say "All skin types" is not one. */
    if (!inDepartment(el, 'Skin')) return false;
    var s = skinScore(el, who);
    return s > 0 || (s === 0 && declaresUniversal(el));
  }

  /* Is this product in the quiz's department ("Skin", "Hair & Scalp")? Read
     from the department's own tags in assets/vro-personalization.js, the
     same list the home page's picks are gated by. */
  function inDepartment(el, key) {
    var e = engine();
    var cat = e && e.categories && e.categories[key];
    if (!cat || !cat.scopeTags || !cat.scopeTags.length) return true;
    var tags = String(el.getAttribute('data-vro-tags') || '').split('|').map(norm);
    /* Tagged into the other department as well (a hair mask that also
       says "Face Masks"): the same exclusion the quiz results apply. */
    var not = cat.excludeTags || [];
    for (var x = 0; x < not.length; x++) {
      if (tags.indexOf(norm(not[x])) > -1) return false;
    }
    for (var i = 0; i < cat.scopeTags.length; i++) {
      if (tags.indexOf(norm(cat.scopeTags[i])) > -1) return true;
    }
    return false;
  }

  /* The skin answer given on this card's Retake, this page view only — the
     doc's "Noted" line. Not stored: a reload shows the recommendation. */
  var skinNoted = null;

  function quizText(answer) {
    return 'Because you picked ' + answer + ' in the quiz, this should suit you well.';
  }

  /* The heading as HTML with the answer in bold: "Your skin is <b>Dry</b>",
     the way the size card reads "Recommended Size is <b>UK 8</b>". */
  function escapeHtml(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function boldIn(heading, part) {
    var h = String(heading || '');
    var i = part ? h.indexOf(part) : -1;
    if (i < 0) return escapeHtml(h);
    return escapeHtml(h.slice(0, i)) + '<b>' + escapeHtml(part) + '</b>' + escapeHtml(h.slice(i + part.length));
  }

  /* The suitability card: shown only for an answer this product fits. */
  function paintFit(who) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp-fit-match]'), function (el) {
      var title = el.querySelector('[data-fit-title]');
      var text = el.querySelector('[data-fit-text]');
      var heading = null;
      var bold = '';
      var line = '';
      if (el.getAttribute('data-fit-kind') === 'fragrance') {
        var scent = scentAnswer();
        var answer = null;
        if (scent) {
          (scent.all || [scent.a]).forEach(function (a) { if (!answer && scentMatches(el, scent, a)) answer = a; });
        }
        if (answer) {
          heading = (el.getAttribute('data-fit-scent-heading') || 'Fits your [scent] scent profile').replace(/\[scent\]/g, answer.toLowerCase());
          line = quizText(answer);
          bold = answer.toLowerCase();
        }
      } else if (skinNoted && el.hasAttribute('data-fit-retake-ready')) {
        heading = 'Noted \u2014 you selected ' + skinNoted;
        line = '';
      } else if (who) {
        if (fitsSkin(el, who)) {
          /* "Your skin is Oily / Because you selected Gets oily by noon in
             the quiz, this will suit you perfectly." */
          heading = 'Your skin is ' + (SKIN_NAMES[who.skin] || who.skin);
          bold = SKIN_NAMES[who.skin] || who.skin;
          line = quizText(who.skinLabel);
        } else {
          for (var i = 0; i < who.problems.length; i++) {
            if (answersProblem(el, who.problems[i])) {
              heading = (el.getAttribute('data-fit-skin-heading') || 'Suits your [skin]').replace(/\[skin\]/g, PROBLEM_PHRASES[who.problems[i]]);
              line = quizText(problemLabel(who.problems[i]));
              bold = PROBLEM_PHRASES[who.problems[i]];
              break;
            }
          }
        }
      }
      /* The grooming template's bar under the pack chips carries this
         recommendation (paintHomeLine); the card itself stays hidden so
         the page shows one bar, not two. */
      el.__vroRec = heading ? { heading: heading, html: boldIn(heading, bold), line: line } : null;
      if (document.querySelector('[data-pdp-home-answer]')) {
        el.hidden = true;
        return;
      }
      var retake = el.querySelector('[data-fit-retake]');
      if (heading && title) {
        title.innerHTML = boldIn(heading, bold);
        if (text) { text.textContent = line; text.hidden = !line; }
        if (retake) retake.hidden = el.classList.contains('is-asking');
        el.hidden = false;
      } else if (!el.classList.contains('is-asking')) {
        el.hidden = true;
      }
    });
  }

  function paintHighlight(who) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp-match]'), function (el) {
      var text = el.querySelector('[data-pdp-match-text]');
      if (!text) return;
      if (!('__vroOriginal' in text)) text.__vroOriginal = text.textContent;
      var phrase = who ? matchPhrase(el, who) : null;
      var next = phrase ? 'Matches your ' + phrase : text.__vroOriginal;
      if (text.textContent !== next) text.textContent = next;
      el.classList.toggle('is-personal', !!phrase);
      /* A product with no highlight of its own ships the line hidden; it
         shows only while there is something true to say. */
      el.hidden = !String(next || '').trim();
    });
  }

  function paintRoutine(who) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp-routine]'), function (box) {
      var fallback = box.getAttribute('data-skin-fallback') || 'your skin';
      var phrase = who ? shopperPhrase(who) : null;
      var skin = phrase ? 'your ' + phrase : fallback;
      Array.prototype.forEach.call(box.querySelectorAll('[data-pdp-routine-text]'), function (el) {
        var tpl = el.getAttribute('data-pdp-routine-text') || '';
        if (tpl.indexOf('[skin]') === -1) return;
        el.textContent = tpl.replace(/\[skin\]/g, skin);
      });

      Array.prototype.forEach.call(box.querySelectorAll('[data-pdp-routine-grid]'), function (grid) {
        var show = parseInt(grid.getAttribute('data-show'), 10) || 4;
        var cards = Array.prototype.slice.call(grid.querySelectorAll(':scope > .feed-card'));
        if (!cards.length) return;
        if (!grid.__vroOrder) grid.__vroOrder = cards.slice();
        var order = grid.__vroOrder;

        var ranked;
        if (!who) {
          ranked = order.slice();
        } else {
          ranked = order.map(function (card, i) {
            var score = 0;
            who.problems.forEach(function (pr, n) {
              if (answersProblem(card, pr)) score += 6 - Math.min(n, 3);
            });
            var s = skinScore(card, who);
            if (s < 0) score -= 10;          /* made for the opposite skin */
            else score += s;
            if (card.getAttribute('data-vro-available') === 'false') score -= 1;
            return { card: card, score: score, i: i };
          }).sort(function (a, b) { return b.score - a.score || a.i - b.i; })
            .map(function (r) { return r.card; });
        }

        var tail = grid.querySelector(':scope > :not(.feed-card)');
        ranked.forEach(function (card, i) {
          card.hidden = i >= show;
          if (tail) grid.insertBefore(card, tail);
          else grid.appendChild(card);
        });
      });
    });
    if (window.VroWishlist && window.VroWishlist.sync) window.VroWishlist.sync();
  }

  /* ---------------- The line under the pack chips ----------------

     "Because on Homepage you selected Gets oily by noon" — the shopper's
     answer to one of the two home-page quizzes that are about grooming:
       - "What does your skin usually do?" (the one-tap card and the rails
         that ask it), and
       - "What are we sorting out?" -> Skin, Hair & Scalp or Fragrance.
     Only an answer this product fits is named. No such answer and the line
     stays hidden: the fixed "200 bros added this to their cart" it replaced
     is never shown. The product's data is read off the suitability card on
     the same page, which carries all of it. */

  function joinLabels(list) {
    if (list.length < 2) return list.join('');
    return list.slice(0, -1).join(', ') + ' & ' + list[list.length - 1];
  }

  /* The current answer to each question, each on its own clock. */
  function homeAnswers(el) {
    var e = engine();
    var p;
    try { p = e && e.profile ? e.profile.get() : null; } catch (err) { p = null; }
    if (!p) return [];
    var facets = p.facets || {};
    var at = p.facetAt || {};
    var out = [];

    /* What their skin does: the newest answer wins, wherever it was given.
       The key 'skin' alone is the one the Retake on this page writes. */
    var skin = null;
    Object.keys(facets).forEach(function (k) {
      var v = facets[k];
      var label = null;
      if (k.split('@')[0] === 'skin' && typeof v === 'string') label = v;
      else if (k.indexOf('answer@') === 0 && v && typeof v === 'object' && v.a &&
               /skin/i.test(String(v.q || '') + ' ' + String(v.s || ''))) label = v.a;
      if (!label || !SKIN_PHRASES[skinConditionOf(label)]) return;
      var when = at[k] || 0;
      if (!skin || when > skin.at) skin = { label: label, at: when, here: k === 'skin' };
    });

    var quiz = p.quiz;
    var cat = null;
    if (quiz && quiz.category) {
      cat = (e.quiz && e.quiz.keyFor) ? (e.quiz.keyFor(quiz.category) || quiz.category) : quiz.category;
    }
    var quizAt = p.quizAt || 0;
    if (cat === 'Skin' && quiz.condition && SKIN_PHRASES[skinConditionOf(quiz.condition)] && (!skin || quizAt > skin.at)) {
      skin = { label: quiz.condition, at: quizAt, here: false };
    }
    if (skin && fitsSkin(el, { skin: skinConditionOf(skin.label) })) {
      out.push({ labels: [skin.label], at: skin.at, here: skin.here });
    }

    /* The concerns picked in "What are we sorting out?" that this product
       answers. */
    if (cat) {
      var picked = [];
      var fragrance = el.getAttribute('data-fit-kind') === 'fragrance';
      (quiz.problems || []).forEach(function (pr) {
        var key = String(pr || '').toLowerCase().trim();
        if (!key) return;
        if ((cat === 'Skin' || cat === 'Hair & Scalp') && !fragrance) {
          if (inDepartment(el, cat) && answersProblem(el, key)) picked.push(String(pr));
        } else if (cat === 'Fragrance' && fragrance) {
          if (scentFits(el, pr)) picked.push(String(pr));
        }
      });
      if (picked.length) {
        /* Same answer as the skin line above when that came from this quiz
           too: one sentence, not two. */
        var same = null;
        for (var i = 0; i < out.length; i++) if (!out[i].here && out[i].at === quizAt) same = out[i];
        if (same) same.labels = picked.concat(same.labels);
        else out.push({ labels: picked, at: quizAt, here: false });
      }
    }

    /* A home-page perfume quiz ("What's your scent profile?", "Which scent
       world pulls you in?") on a perfume this answer fits. */
    if (el.getAttribute('data-fit-kind') === 'fragrance') {
      var sc = scentAnswer();
      if (sc && sc.source === 'answer' && scentMatches(el, sc, sc.a)) {
        out.push({ labels: [sc.a], at: sc.at, here: false });
      }
    }
    return out;
  }

  function paintHomeLine() {
    var source = document.querySelector('[data-pdp-fit-match]');
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp-home-answer]'), function (box) {
      var text = box.querySelector('[data-home-answer-text]');
      var head = box.querySelector('[data-home-answer-title]');
      /* The recommendation first: "Your skin is Dry / Because you selected
         Feels tight and dry in the quiz, this will suit you perfectly". */
      var rec = source && source.__vroRec;
      if (rec && text) {
        if (head) { head.innerHTML = rec.html; head.hidden = false; }
        text.textContent = rec.line || '';
        text.hidden = !rec.line;
        box.hidden = false;
        return;
      }
      if (head) { head.textContent = ''; head.hidden = true; }
      if (text) text.hidden = false;
      var found = source ? homeAnswers(source) : [];
      found.sort(function (a, b) { return b.at - a.at; });
      var hit = found[0];
      if (!hit || !text) { box.hidden = true; return; }
      var answer = joinLabels(hit.labels);
      var tpl = box.getAttribute('data-template') || 'Because on Homepage you selected [answer]';
      /* Answered on this page's Retake, not on the home page. */
      var line = hit.here ? 'Because you selected ' + answer : tpl.replace(/\[answer\]/g, answer);
      if (text.textContent !== line) text.textContent = line;
      box.hidden = false;
    });
  }

  function run() {
    var who = shopper();
    paintHighlight(who);
    paintFit(who);
    paintRoutine(who);
    paintHomeLine();
  }

  /* Retake on the suitability card: the skin question, asked in place.
     The answer is filed on the profile like the home page's own answer
     (facet 'skin'), so every grooming PDP and rail reads it. */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var retake = t.closest('[data-fit-retake]');
    var chip = t.closest('[data-fit-skin]');
    if (!retake && !chip) return;
    var card = t.closest('[data-pdp-fit-match]');
    if (!card) return;
    e.preventDefault();
    var options = card.querySelector('[data-fit-options]');
    if (retake && card.getAttribute('data-fit-kind') === 'fragrance') {
      /* The scent answer comes from a quiz with its own modal; ask it
         there. The modal saves what it is told (assets/quiz.js). */
      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.hidden = true;
      trigger.setAttribute('data-quiz-open', '');
      document.body.appendChild(trigger);
      trigger.click();
      setTimeout(function () { trigger.remove(); }, 0);
      return;
    }
    if (retake) {
      card.classList.add('is-asking');
      card.setAttribute('data-fit-retake-ready', '');
      retake.hidden = true;
      if (options) options.hidden = false;
      var who = shopper();
      Array.prototype.forEach.call(card.querySelectorAll('[data-fit-skin]'), function (b) {
        b.setAttribute('aria-pressed', who && who.skinLabel === b.getAttribute('data-fit-skin') ? 'true' : 'false');
      });
      return;
    }
    var label = chip.getAttribute('data-fit-skin');
    Array.prototype.forEach.call(card.querySelectorAll('[data-fit-skin]'), function (b) {
      b.setAttribute('aria-pressed', b === chip ? 'true' : 'false');
    });
    skinNoted = label;
    card.classList.remove('is-asking');
    if (options) options.hidden = true;
    var eng = engine();
    if (eng && eng.profile && eng.profile.setFacet) eng.profile.setFacet('skin', label);
    run();
  });

  /* Back/forward cache: coming back is not answering. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    skinNoted = null;
    run();
  });

  window.VroPdpMatch = { run: run, shopper: shopper };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  /* vro-personalization.js is deferred too and may land after us. */
  window.addEventListener('load', run);
  document.addEventListener('vro:profile:change', run);
  document.addEventListener('vro:personalization:ready', run);
})();
